import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch, post } from "../../Util/axios_helper";
import { InfoIcon } from "../../Util/common";

const initialState = {
  //email content
  emailTemplates: [],
  emailTemplatesLoaded: true,
  templateFields: [],
  templateFieldsLoaded: true,
  selTemplate: null,
  clearTemplate: 0,
  cursorPosition: 0,
  //ballroom Images
  ballrooms: [],
  ballroomsLoaded: false,
  imageContent: {},
  imageContentLoaded: false,
};

//email content
export const getEmailTemplates = createAsyncThunk(
  "getEmailTemplates",
  async () => {
    return await fetch("EmailTemplate/GetEmailTemplates");
  }
);

// export const getTemplateDataFields = createAsyncThunk(
//   "getTemplateDataFields",
//   async (emailType) => {
//

//     return await fetch(`EmailTemplate/GetDataFields?type=${emailType}`);
//   }
// );

export const getTemplateDataFields = createAsyncThunk(
  "getTemplateDataFields",
  async (emailType) => {
    console.log("Email Type:", emailType); // 🔍 Check emailType
    const response = await fetch(
      `EmailTemplate/GetDataFields?type=${emailType}`
    );

    if (emailType === "MERIDIAN" || emailType === "NON_MERIDIAN") {
      console.log("Inside MERIDIAN Condition"); // ✅ Check if it enters

      const hasItemFields = response.some(
        (field) =>
          field.DataFieldName === "ItemName" ||
          field.DataFieldName === "Category" ||
          field.DataFieldName === "Quantity" ||
          field.DataFieldName === "Item Image"
      );

      console.log("Has Item Fields:", hasItemFields); // ✅ Debugging

      if (hasItemFields) {
        // ✅ Remove individual fields
        const filteredData = response.filter(
          (field) =>
            !["ItemName", "Category", "Quantity", "Item Image"].includes(
              field.DataFieldName
            )
        );

        // ✅ Add new grouped field
        filteredData.push({
          TemplateDataFieldId: "ItemDetails",
          DataFieldName: "ItemDetails",
        });

        console.log("Filtered Data (MERIDIAN):", filteredData); // ✅ Debugging
        return filteredData;
      }
    }

    return response; // ✅ Always return data
  }
);

//ballroom Images
export const getBallRoomList = createAsyncThunk("getBallRoomList", async () => {
  return await fetch("Configuration/GetBallroomListForDrop");
});

export const getBallroomImageContent = createAsyncThunk(
  "getBallroomImageContent",
  async (data) => {
    return await fetch(
      `EmailTemplate/GetBallroomEventImage?EventId=${data.eventId}&BallroomId=${data.ballroomId}`
    );
  }
);

const emailTemplateSlice = createSlice({
  name: "EmailTemplate",
  initialState: initialState,
  reducers: {
    onClear: (state) => {
      if (state.selTemplate) {
        state.clearTemplate = state.clearTemplate + 1;
        let index = state.emailTemplates.findIndex(
          (e) => e.EmailTemplateId == state.selTemplate.EmailTemplateId
        );
        if (index != -1) {
          state.selTemplate = state.emailTemplates[index];
        }
      }
    },
    onTemplateChange: (state, action) => {
      let index = state.emailTemplates.findIndex(
        (e) => e.EmailTemplateId == action.payload
      );
      if (index != -1) {
        state.selTemplate = state.emailTemplates[index];
      }
    },
    onSubjectChange: (state, data) => {
      if (state.selTemplate) {
        state.selTemplate.Subject = data.payload;
      }
    },
    onCursorPositionChange: (state, data) => {
      state.cursorPosition = data.payload;
    },
    setEditorContent: (state, data) => {
      state.selTemplate.Body = data.payload;
    },
  },
  extraReducers: (builder) => {
    //email content
    builder.addCase(getEmailTemplates.pending, (state) => {
      state.emailTemplatesLoaded = true;
    });

    builder.addCase(getEmailTemplates.fulfilled, (state, action) => {
      state.emailTemplatesLoaded = false;
      state.emailTemplates = action.payload || [];
      if (!state.selTemplate) {
        state.selTemplate =
          action.payload && action.payload.length > 0 && action.payload[0];
      }
    });

    builder.addCase(getEmailTemplates.rejected, (state) => {
      state.emailTemplatesLoaded = false;
      state.emailTemplates = [];
    });
    //templateFields
    builder.addCase(getTemplateDataFields.pending, (state) => {
      state.templateFieldsLoaded = true;
    });

    builder.addCase(getTemplateDataFields.fulfilled, (state, action) => {
      (state.templateFieldsLoaded = false),
        (state.templateFields = action.payload || []);
    });

    builder.addCase(getTemplateDataFields.rejected, (state) => {
      state.templateFieldsLoaded = false;
      state.templateFields = [];
    });
    //ballroom Images
    builder.addCase(getBallRoomList.pending, (state) => {
      state.ballroomsLoaded = false;
    });

    builder.addCase(getBallRoomList.fulfilled, (state, action) => {
      state.ballroomsLoaded = true;
      state.ballrooms = action.payload || [];
    });

    builder.addCase(getBallRoomList.rejected, (state) => {
      state.ballroomsLoaded = true;
      state.ballrooms = [];
    });

    builder.addCase(getBallroomImageContent.pending, (state) => {
      state.imageContentLoaded = false;
    });

    builder.addCase(getBallroomImageContent.fulfilled, (state, action) => {
      state.imageContentLoaded = true;
      state.imageContent = action.payload;
    });

    builder.addCase(getBallroomImageContent.rejected, (state) => {
      state.imageContentLoaded = true;
      state.imageContent = {};
    });
  },
});

export const {
  onTemplateChange,
  onSubjectChange,
  onClear,
  onCursorPositionChange,
  setEditorContent,
} = emailTemplateSlice.actions;

export default emailTemplateSlice.reducer;
